import axios from 'axios';
import moment from 'moment';

export default {
    namespaced: true,

    state: {
        doublesActivity: [],
        loadingEntryActivity: false,
        loadingErrorEntryActivity: null,
    },

    getters: {
        doublesActivity: (state) => state.doublesActivity,
        loadingEntryActivity: (state) => state.loadingEntryActivity,
        loadingErrorEntryActivity: (state) => state.loadingErrorEntryActivity,
    },

    mutations: {
        setEntryActivity(state, data) { state.doublesActivity = data },

        startLoadingEntryActivity(state) { state.loadingWithdrawableEntries = true; },
        stopLoadingEntryActivity(state) { state.loadingWithdrawableEntries = false; },

        setLoadingErrorEntryActivity(state, error) { state.loadingErrorWithdrawableEntries = error; },
        clearLoadingErrorEntryActivity(state) { state.loadingErrorWithdrawableEntries = null; },
    },

    actions: {
        async getDoublesActivity(context, options = {}) {
            context.commit('startLoadingEntryActivity');
            context.commit('clearLoadingErrorEntryActivity');
            try {
                var result = await axios.get(`${HOST_NAME}/api/DoublesEntry/EntryHistory/${options.playerNbr}`);
                context.commit('setEntryActivity', result.data);
                context.commit('stopLoadingEntryActivity');
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('setLoadingErrorEntryActivity', error);
                context.commit('stopLoadingEntryActivity');
                return Promise.reject(error);
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/doubles/entry-activity.js